export const HOST = "https://app.bizzer.xyz"

export function buildDeleteUrl(isClean: boolean): string {
    return `${HOST}/user/profile?isClean=${isClean}`
}